import React from "react";
import { makeStyles } from "@material-ui/core";
import { convertNumberToPersian } from "../../../../method/convertDigitToEnglish";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 560,
    margin: "0 auto",
    padding: "24px 16px",
    textAlign: "center",
  },
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  row: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  label: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  link: {
    color: theme.palette.primary?.main || "#1976d2",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

const TELEGRAM_LINK = "https://t.me/pouyanbrokerage";

export default function ContactInfo() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h3 className={classes.title}>راه‌های ارتباطی</h3>
      <div className={classes.row}>
        <span className={classes.label}>شماره تماس:</span>
        <span>
          <a href="tel:02191005777">{convertNumberToPersian("021-91005777")}</a>
          <span style={{ margin: "0 8px" }}>|</span>
          <a href="tel:02153782000">{convertNumberToPersian("021-53782000")}</a>
        </span>
      </div>
      <div className={classes.row}>
        <span className={classes.label}>تلگرام:</span>
        <a
          href={TELEGRAM_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          t.me/pouyanbrokerage
        </a>
      </div>
    </div>
  );
}
